const DAILY = { value: "DAILY", displayName: "Täglich" };
const WEEKLY = { value: "WEEKLY", displayName: "Wöchentlich" };
const MONTHLY = { value: "MONTHLY", displayName: "Monatlich" };

export const AUTO_IMPORT_PERIOD = {
    DAILY, 
    WEEKLY, 
    MONTHLY
};
